/**
 * Autocomplete popover above the composer. Floats with a subtle
 * shadow + hairline border so it reads as a layer above the chat
 * surface, not a panel attached to it.
 */
import { COMMANDS } from "./slash";

interface Props {
  suggestions: ReadonlyArray<(typeof COMMANDS)[number]>;
  onPick: (commandName: string) => void;
}

export function SlashPalette({
  suggestions,
  onPick,
}: Props): React.ReactElement | null {
  if (suggestions.length === 0) return null;
  return (
    <div
      className="absolute bottom-full left-3 right-3 mb-1.5 rounded-[14px] overflow-hidden"
      style={{
        background: "var(--color-bg)",
        boxShadow: "var(--shadow-2)",
      }}
    >
      <ul className="max-h-60 overflow-y-auto py-1">
        {suggestions.map((c) => (
          <li key={c.name}>
            <button
              type="button"
              className="w-full text-left px-3 py-2 flex items-center gap-2 active:opacity-70"
              onClick={() => onPick(c.name)}
            >
              <span
                className="font-mono text-[13px] shrink-0"
                style={{ color: "var(--color-link)" }}
              >
                /{c.name}
              </span>
              <span
                className="text-[11px] truncate"
                style={{ color: "var(--color-hint)" }}
              >
                {c.hint}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
